<h6 mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">person</mat-icon>
  {{ 'inventory.popups.assign.title' | translate }}
</h6>
<div class="popup-subtitle mb-1">
  {{ 'inventory.popups.assign.subtitle' | translate }}
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="AssignAssetForm">
    <div class="row">
      <div class="col-md-12">
        <el-async-autocomplete
          label="{{ 'inventory.popups.form.assign' | translate }} "
          [filteredOptionsFromParent]="assignee"
          [selectionModes]="SELECTION_MODE.PLAIN"
          [size]="10"
          [total]="1"
          [isMultiSelectEnabled]="false"
          [selectedForEdit]="selectedUsers"
          [disabled]="isView"
          (selectedItems)="selectUser($event)"
          (asyncInput)="onFilterUsers($event)"
          [isRequired]="true"
        >
        </el-async-autocomplete>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'inventory.popups.form.lend-date' | translate
          }}</mat-label>
          <input
            data-testid="inventory_asset_lend_date"
            placeholder="{{ 'inventory.popups.form.lend-date' | translate }}"
            type="text"
            matInput
            [min]="minDate"
            formControlName="lend_on_date"
            [matDatepicker]="pickerA"
            (click)="pickerA.open()"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerA"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerA></mat-datepicker>
          <mat-error>{{
            'inventory.add-edit.form.required.lend-date' | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'inventory.popups.form.return-date' | translate
          }}</mat-label>
          <input
            data-testid="inventory_asset_return_date"
            type="text"
            placeholder="{{ 'inventory.popups.form.return-date' | translate }}"
            matInput
            formControlName="return_on_date"
            [min]="AssignAssetForm.controls.lend_on_date.value"
            [matDatepicker]="pickerB"
            (click)="pickerB.open()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerB"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerB></mat-datepicker>
          <mat-error>
            {{ 'inventory.popups.form.return-date' | translate }}
            {{ 'inventory.add-edit.form.required.error-date' | translate }}
            {{ 'inventory.popups.form.lend-date' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div *ngIf="!isView">
    <button
      mat-flat-button
      color="primary"
      (click)="onAssign()"
      [disabled]="this.AssignAssetForm.invalid"
    >
      {{ 'inventory.add-edit.form.save' | translate }}
    </button>
  </div>
  <button mat-flat-button class="button-style" (click)="onClose()">
    Cancel
  </button>
</mat-dialog-actions>
